import { bl_fi_filing_event_RowClass } from '../../../dbschema';
import {BaseContainerModel} from '../../base-container.model';

export class FilingEventModel extends BaseContainerModel{
    bl_fi_filing_event: bl_fi_filing_event_RowClass = new bl_fi_filing_event_RowClass();
    }